export function addTransition(original: string, transition: string) {
  const trimmed = transition.trim();
  const name = trimmed.split(' ')[0];
  const withoutNewTransition = removeTransition(original, name);
  const transitions = getTransitions(withoutNewTransition);
  const final = [...transitions, trimmed].join(', ');
  return final;
}

export function removeTransition(original: string, transitionName: string) {
  const transitions = getTransitions(original);
  const filtered = transitions.filter((t) => !t.startsWith(transitionName));
  const final = filtered.join(', ');
  return final;
}

export function getTransitions(transitions: string): string[] {
  return transitions
    .split(',')
    .map((t) => t.trim())
    .filter((t) => t.length > 0);
}
